// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1HsUh","text":"SelectPayment_text__184ng","title":"SelectPayment_title__QA51P","btn":"SelectPayment_btn__13Fug"};